export const PASSWORD_DEFAULTS = { MAX_LENGTH: 64, MIN_LENGTH: 9 };
export const ORIGIN_IS_SSO_EVENT_LINK = "sso-trigger";
export const ORIGIN_IS_SSO_EVENT_LINK_VALUE = "1";

export enum PROVIDERS {
  EDC = "events.com",
  FACEBOOK = "facebook",
  GOOGLE = "google",
  LINKEDIN = "linkedin",
  MICROSOFT = "microsoft",
}

export const SSO_TOKEN_KEY = "sso-token";
export const SSO_ERROR_KEY = "sso-error";
export const SSO_ERROR_EMAIL = "sso-error-email";
export const WAIT_FOR_KEYS_IN_LOCAL_STORAGE_INTERVAL = 500;

export const EDC_SSO_REDIRECT_PATH = "edc-sso-redirect-path";

export const LINKEDIN_POPUP_BROWSING_CONTEXT = "linkedinAuth";

export const MAGIC_LINK_EMAIL_KEY = "magic-link-login-email";

export const SOCIAL_PROVIDERS = [
  PROVIDERS.EDC,
  PROVIDERS.MICROSOFT,
  PROVIDERS.GOOGLE,
  PROVIDERS.FACEBOOK,
  PROVIDERS.LINKEDIN,
];

export const SOCIAL_PROVIDERS_SSO_PATHS = SOCIAL_PROVIDERS.map(
  (providerName) => `/${providerName}/sso`,
);

export const ANONYMOUS_USER_EMAIL_DOMAIN = "@remo1.co";

export const trialFirstNameKey = "trialFirstNameTemp";
export const trialLastNameKey = "trialLastNameTemp";
export const trialPhoneKey = "trialPhoneTemp";

// default assumed otherwise
export const CHECK_EMAIL_TO_LOGIN_MODES = {
  EVENT_REGISTRATION: "event.registration",
  JOIN_EVENT: "join.event",
  TRIAL: "trial",
};
